import React, { useEffect, useState, useContext, useCallback } from "react";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Chip,
  Grid,
  Dialog,
  Alert,
  Snackbar,
} from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import useAxiosConfig from "../config/AxiosConfig";
import CreatePromoForm from "../component/CreatePromoForm";
import { AuthContext } from "../auth/ContextAuthentication";

const ViewAllPromotions = () => {
  // const [] = useState([]);
  const [grounds, setGrounds] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPromotion, setSelectedPromotion] = useState(null);
  const { editPromotion, setEditPromotion } = useContext(AuthContext);
  const { promotions, setPromotions } = useContext(AuthContext);
  const { selectedPromotionID, setSelectedPromotionID } =
    useContext(AuthContext);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const axiosInstance = useAxiosConfig();

  const fetchGroundData = useCallback(async () => {
    try {
      // const response = await axiosInstance.get("/api/admin/getGrounds");
      const response = await axiosInstance.get(
        "/api/admin/get-all-bookings-grounds?filter=all"
      );
      if (response.status === 200) {
        // const groundMap = response.data.grounds.reduce((acc, ground) => {
        //   acc[ground._id] = ground.name;
        //   return acc;
        // }, {});
        setGrounds(response.data.data);
      }
    } catch (error) {
      console.log("Error fetching ground data:", error);
    }
  }, [axiosInstance]);

  const fetchPromotions = useCallback(async () => {
    try {
      const response = await axiosInstance.get("api/admin/get-promo-code");
      if (response.data.status) {
        setPromotions(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching promotions:", error);
    }
  }, [axiosInstance, setPromotions]);

  useEffect(() => {
    fetchPromotions();
    fetchGroundData();
  }, [fetchGroundData, fetchPromotions]);

  const editPromo = async (data) => {
    handleClose();
    try {
      // Create new promotion
      const response = await axiosInstance.put("api/admin/edit-promo-code", {
        ...data,
        promoId: selectedPromotionID,
      });
      fetchPromotions();
      if (
        response.status === 201 ||
        (response.status === 200 && response.data.status === true)
      ) {
        setSuccessMessage("Promo code updated successfully");
      } else {
        setErrorMessage(response.data.message || "Error updating promo code");
      }
    } catch (error) {
      console.error("Error creating/updating promo code:", error);
      setErrorMessage(
        error.response?.data?.message || "Error updating promo code"
      );
    }
  };

  const handleClick = (event, promotion) => {
    setAnchorEl(event.currentTarget);
    setSelectedPromotion(promotion);
  };

  const handleCloseSnackbar = () => {
    setSuccessMessage("");
    setErrorMessage("");
  };

  const handleClose = () => {
    setEditPromotion(false);
    setAnchorEl(null);
    setSelectedPromotion(null);
  };

  const handleDelete = async () => {
    if (!selectedPromotion) return;
    try {
      await axiosInstance.delete(
        `api/admin/delete-promo/${selectedPromotion._id}`
      );
      setPromotions((prev) =>
        prev.filter((promo) => promo._id !== selectedPromotion._id)
      );
      handleClose();
    } catch (error) {
      console.error("Error deleting promotion:", error);
    }
  };

  const handleEditModal = (id) => {
    setEditPromotion(true);
    setSelectedPromotionID(id);
  };

  return (
    <>
      <div className="w-full flex flex-col items-center justify-center gap-4 my-28">
        {promotions.map((promotion) => (
          <Card
            key={promotion._id}
            // onClick={() => console.log(promotion._id)}
            style={{
              width: "70%",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.10)",
              borderRadius: "10px",
              padding: 2,
            }}
          >
            <CardContent
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Grid style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <Typography variant="h6">{promotion.code}</Typography>
                  <Chip
                    label={promotion.discount}
                    color="success"
                    size="small"
                  />
                </Grid>
                <Typography variant="body2" color="textSecondary">
                  {/* look upon this thingggggggggg */}
                  {console.log("first")}
                  {!promotion.appliesToAllGrounds
                    ? promotion.groundIds
                        .map((item) => {
                          const final = grounds.find(
                            (check) => check._id === item
                          );
                          console.log("second");
                          return final ? final.name : null;
                        })
                        .filter((name) => name !== null)
                        .join(", ")
                    : "All Grounds"}
                  {console.log("thirds")}
                </Typography>
                <Typography
                  variant="body2"
                  color={
                    new Date(promotion.expiryDate) <
                    new Date(new Date().setHours(0, 0, 0, 0))
                      ? "error"
                      : "#0C7240"
                  }
                >
                  {`${
                    new Date(promotion.expiryDate) <
                    new Date(new Date().setHours(0, 0, 0, 0))
                      ? "Expired"
                      : "Expires"
                  } on: ${new Date(promotion.expiryDate).toLocaleDateString()}`}
                </Typography>
                {/* <Typography variant="body2" color="error">
                  {`Expires on: ${new Date(
                    promotion.expiryDate
                  ).toLocaleDateString()}`}
                </Typography> */}
              </div>
              <IconButton
                aria-label="more"
                onClick={(event) => handleClick(event, promotion)}
                sx={{
                  padding: "18px",
                  borderRadius: "50%",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                  },
                }}
              >
                <MoreVertIcon />
              </IconButton>
            </CardContent>

            <Menu
              anchorEl={anchorEl}
              open={selectedPromotion?._id === promotion._id}
              onClose={handleClose}
            >
              <MenuItem onClick={() => handleEditModal(promotion._id)}>
                Edit
              </MenuItem>
              <MenuItem onClick={handleDelete}>Delete</MenuItem>
            </Menu>
          </Card>
        ))}
      </div>
      <Dialog open={editPromotion} onClose={handleClose} maxWidth="sm">
        {/* <DialogTitle>Create Promotion</DialogTitle>
        <DialogContent dividers> */}
        <CreatePromoForm
          title="Edit Promotion"
          onSubmit={editPromo}
          // forward onSuccess to close modal when done
          // onSuccess={() => {
          //   handleClose();
          //   onSuccess?.();
          // }}
        />
        {/* </DialogContent> */}
        {/* <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions> */}
      </Dialog>
      <Snackbar
        open={!!successMessage}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          {successMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={!!errorMessage}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ViewAllPromotions;
